import ComingSoon from "../../../components/comingSoon/ComingSoon";

const VoiceInterviewprepDashboard = () => {
  return (
    <ComingSoon
      content={
        <div className="text-left font-normal text-gray-800 text-sm sm:text-base">
          <h2 className="text-lg sm:text-xl font-semibold mb-2">
            Coming Soon: Voice Interview Prep — Nail Your Next Interview
          </h2>

          <p className="mb-6">
            A smarter, hands-on way to practice interviews is on the way.
          </p>

          <p className="font-semibold mb-2">What It Will Do</p>
          <ul className="list-disc pl-5 space-y-4">
            <li>
              <p>
                <strong>Real-Time, Voice-Activated Mock Interviews</strong><br />
                Choose a job role, seniority level, and the length of your practice session, then answer questions aloud as if you’re in a live interview.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant AI Feedback & Scoring</strong><br />
                Get rapid-fire insights on clarity, structure, key skill keywords, pacing, filler-word usage, tone, and confidence markers.
              </p>
            </li>
            <li>
              <p>
                <strong>Adaptive Questioning</strong><br />
                Our engine follows up with probing questions—just like a seasoned recruiter would—based on your previous answers and the competencies that matter most for the role.
              </p>
            </li>
            <li>
              <p>
                <strong>Personalized Improvement Plan</strong><br />
                Receive a prioritized action list, tailored micro-lessons, and repeat-after-me drills to refine your storytelling, quantify achievements, and manage interview nerves.
              </p>
            </li>
            <li>
              <p>
                <strong>Shareable Insights</strong><br />
                Opt-in to share your interview scorecard with mentors—or even potential employers via Ontrack’s AI Talent Pool—to showcase your progress.
              </p>
            </li>
          </ul>
        </div>
      }
    />
  );
};

export default VoiceInterviewprepDashboard;
